/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SearchEmployeesRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/utility_messages.pb'
import {SearchEmployeesResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/utility_messages.pb'


export const searchEmployees = (request: SearchEmployeesRequest, options?: CashRequestOptions) => post<SearchEmployeesRequest, SearchEmployeesResponse>("/2.0/cash/search-employees", request, {...options, rejectOnError: true })